import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["searchable", "autoAlign", "autoFocusSearch", "popoverWidth", "popoverClassName", "zIndex", "emptyRender", "emptyContent", "searchPlaceholder", "onSearchChange", "value", "disabled", "readonly", "filterOption", "placement", "autoClearSearchValue", "children", "renderSelected", "placeholder", "onValueChange", "loading", "renderLoading", "renderFooter", "show", "onHide", "onShow", "onVisibleChange", "defaultShow", "alwayRenderSelected"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file Select
 */
import { guid } from '@tencent/glue-util-helper';
import React from 'react';
import { usePrefixCls } from '../../hooks/usePrefix';
import { ViewSelectTrigger } from '../../views/ViewSelectTrigger';
import { SelectContainer } from './SelectContainer';

var SelectedRender = function SelectedRender(ops) {
  var prefix = usePrefixCls('single-value');
  var displayItem = ops.displayItem,
      renderSelected = ops.renderSelected;

  if (renderSelected) {
    return React.createElement(React.Fragment, null, renderSelected(displayItem));
  }

  return React.createElement("span", {
    className: prefix,
    title: displayItem.label
  }, displayItem.label);
};

export function Select(props) {
  var searchable = props.searchable,
      autoAlign = props.autoAlign,
      autoFocusSearch = props.autoFocusSearch,
      popoverWidth = props.popoverWidth,
      popoverClassName = props.popoverClassName,
      zIndex = props.zIndex,
      emptyRender = props.emptyRender,
      emptyContent = props.emptyContent,
      searchPlaceholder = props.searchPlaceholder,
      onSearchChange = props.onSearchChange,
      value = props.value,
      disabled = props.disabled,
      readonly = props.readonly,
      filterOption = props.filterOption,
      placement = props.placement,
      autoClearSearchValue = props.autoClearSearchValue,
      children = props.children,
      renderSelected = props.renderSelected,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? '请选择' : _props$placeholder,
      onValueChange = props.onValueChange,
      loading = props.loading,
      renderLoading = props.renderLoading,
      renderFooter = props.renderFooter,
      show = props.show,
      onHide = props.onHide,
      onShow = props.onShow,
      onVisibleChange = props.onVisibleChange,
      defaultShow = props.defaultShow,
      alwayRenderSelected = props.alwayRenderSelected,
      extra = _objectWithoutProperties(props, _excluded);

  var container = {
    searchable: searchable,
    autoAlign: autoAlign,
    autoFocusSearch: autoFocusSearch,
    popoverWidth: popoverWidth,
    emptyRender: emptyRender,
    emptyContent: emptyContent,
    searchPlaceholder: searchPlaceholder,
    onSearchChange: onSearchChange,
    value: value,
    onValueChange: onValueChange,
    disabled: disabled,
    readonly: readonly,
    filterOption: filterOption,
    placement: placement,
    autoClearSearchValue: autoClearSearchValue,
    children: children,
    loading: loading,
    renderLoading: renderLoading,
    renderFooter: renderFooter,
    show: show,
    onHide: onHide,
    onShow: onShow,
    onVisibleChange: onVisibleChange,
    popoverClassName: popoverClassName,
    zIndex: zIndex,
    defaultShow: defaultShow
  };

  var renderTrigger = function renderTrigger(ref, show, display) {
    var displayItem = display === null || display === void 0 ? void 0 : display[0];
    var selectNode = displayItem ? React.createElement(SelectedRender, {
      displayItem: displayItem,
      renderSelected: renderSelected
    }) : placeholder;

    if (alwayRenderSelected) {
      var _displayItem = {
        id: guid(),
        label: '',
        value: value
      };
      selectNode = React.createElement(SelectedRender, {
        displayItem: _displayItem,
        renderSelected: renderSelected
      });
    }

    return React.createElement(ViewSelectTrigger, _objectSpread(_objectSpread({}, extra), {}, {
      elRef: ref,
      disabled: disabled,
      show: show,
      empty: !displayItem
    }), selectNode);
  };

  return React.createElement(SelectContainer, _objectSpread({
    renderTrigger: renderTrigger
  }, container));
}